(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["private-sales-access"] && !Shopify.designMode) return;
  try {
    
  class PrivateSalesFormStyle extends HTMLElement {
    #observer;
    #sheet;
    connectedCallback() {
      this.#sheet = new CSSStyleSheet();
      this.#sheet.replaceSync(`
        [class*="_appEmbedRoot_"], [class*="_appEmbedRoot_"] * { font-family: 'Gotham', Arial, sans-serif !important; }
        h2[class*="_textHeading_"] { font-family: 'Garamond', Georgia, serif !important; color: #000 !important; font-size: 26px !important; }
        button[class*="_formSubmitButton_"] { background: #000 !important; color: #fff !important; border-radius: 5px !important; font-size: 12px !important; }
        button[class*="_formSubmitButton_"]:hover { background: #222 !important; }
      `);
      this.#observer = new MutationObserver(() => this.#apply());
      this.#observer.observe(this, { childList: true, subtree: true });
      this.#apply();
    }
    #apply() {
      this.querySelectorAll('shopify-forms-embed').forEach((embed) => {
        if (embed.shadowRoot && !embed.shadowRoot.adoptedStyleSheets.includes(this.#sheet)) {
          embed.shadowRoot.adoptedStyleSheets = [...embed.shadowRoot.adoptedStyleSheets, this.#sheet];
          this.#observer.observe(embed.shadowRoot, { childList: true, subtree: true });
        }
      });
    }
    disconnectedCallback() { this.#observer?.disconnect(); }
  }
  if (!customElements.get('private-sales-form-style')) customElements.define('private-sales-form-style', PrivateSalesFormStyle);

  } catch(e) { console.error(e); }
})();
})();
